"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaperSize;
(function (PaperSize) {
    PaperSize["A4"] = "A4";
    PaperSize["Letter"] = "Letter";
})(PaperSize = exports.PaperSize || (exports.PaperSize = {}));
var FileType;
(function (FileType) {
    FileType["Png"] = "png";
    FileType["Pdf"] = "pdf";
    FileType["Html"] = "html";
    FileType["Xlsx"] = "xlsx";
})(FileType = exports.FileType || (exports.FileType = {}));
var ContentType;
(function (ContentType) {
    ContentType["Pdf"] = "application/pdf";
    ContentType["Png"] = "image/png";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
exports.SNAPSHOTS_EXPORT_LIMIT = 2;
//# sourceMappingURL=export.js.map